import { useState, useRef, useEffect } from 'react';

const testimonials = [
  {
    id: 1,
    name: '김지은',
    course: '반영구 문신 마스터 과정',
    period: '2024년 수료',
    rating: 5,
    avatar: 'https://public.readdy.ai/ai/img_res/1e4145b97256aa82556e0cf5de35e629.jpg',
    review: '반영구 문신을 배우고 싶어서 여러 기관을 알아봤는데, 대한문신사중앙회 중구지부가 본회 공식 자격증까지 취득할 수 있는 유일한 곳이었어요. 강사님들이 기초부터 실전까지 정말 꼼꼼하게 지도해 주셔서 수료 후 바로 샵을 오픈할 수 있었습니다. 창업 컨설팅 지원도 너무 든든했어요.',
    tag: '현재 샵 운영 중',
  },
  {
    id: 2,
    name: '박성훈',
    course: '반영구 문신 전문가 과정',
    period: '2024년 수료',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Korean%20male%20semi-permanent%20tattoo%20specialist%20in%20his%20early%2030s%2C%20confident%20smile%2C%20artistic%20studio%20background%2C%20professional%20headshot%20portrait%20photography%2C%20warm%20lighting&width=200&height=200&seq=testi2&orientation=squarish',
    review: '반영구 문신 기술을 제대로 배우고 싶어서 등록했는데, 커리큘럼이 정말 체계적이었어요. 색소학부터 피부 이론, 실제 모델 실습까지 단계별로 탄탄하게 구성되어 있어서 자신감이 생겼습니다. 본회 공식 자격증 취득 후 지금은 프리랜서로 활발하게 활동 중이에요.',
    tag: '프리랜서 아티스트 활동',
  },
  {
    id: 3,
    name: '이수민',
    course: 'SMP 두피문신 전문가 과정',
    period: '2023년 수료',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Korean%20female%20beauty%20specialist%20in%20her%20mid%2030s%2C%20warm%20professional%20smile%2C%20clean%20bright%20background%2C%20professional%20headshot%20portrait%20photography%2C%20natural%20lighting&width=200&height=200&seq=testi3&orientation=squarish',
    review: 'SMP 두피문신은 고도의 전문성이 필요한 분야인데, 중구지부 강사님들의 실무 경력이 워낙 풍부하셔서 현장에서 바로 적용 가능한 기술을 배울 수 있었어요. 위생교육도 지부에서 한 번에 해결할 수 있어서 정말 편리했고, 수료 후 SMP 전문가로 활동하면서 수입도 크게 늘었습니다.',
    tag: 'SMP 전문가 활동 중',
  },
  {
    id: 4,
    name: '최다현',
    course: '반영구 문신 마스터 과정',
    period: '2023년 수료',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Korean%20female%20semi-permanent%20tattoo%20artist%20in%20her%20late%2020s%2C%20bright%20confident%20smile%2C%20modern%20studio%20background%2C%20professional%20headshot%20portrait%20photography%2C%20soft%20natural%20lighting&width=200&height=200&seq=testi4&orientation=squarish',
    review: '직장을 다니면서 주말반으로 수강했는데 일정 조율이 정말 잘 됐어요. 반영구 문신 기술을 체계적으로 배울 수 있었고, 위생교육 이수증 발급까지 지부에서 원스톱으로 해결했습니다. 자격증 취득 후 부업으로 시작해서 지금은 전업 아티스트로 전환했어요.',
    tag: '전업 아티스트 전환',
  },
];

export default function TestimonialSection() {
  const [active, setActive] = useState(0);
  const ref = useRef<HTMLElement | null>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setIsVisible(true); observer.unobserve(el); } },
      { threshold: 0.08 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref as React.RefObject<HTMLElement>} className="py-16 md:py-24 bg-[#1B3A6B] overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 md:px-6">
        {/* Header */}
        <div className={`flex flex-col md:flex-row md:items-end justify-between mb-10 md:mb-14 gap-4 anim-fade-up ${isVisible ? 'is-visible' : ''}`}>
          <div className="text-center md:text-left">
            <span className="inline-block text-xs font-bold tracking-widest text-[#C9A84C] uppercase border border-[#C9A84C]/40 rounded-sm px-3 py-1 mb-4">
              수강생 후기
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-black text-white">
              수료생들의 생생한 이야기
            </h2>
          </div>
          <p className="text-white/40 text-sm max-w-xs leading-relaxed text-center md:text-right mx-auto md:mx-0">
            중구지부를 통해 꿈을 이룬 수료생들의 실제 후기입니다
          </p>
        </div>

        {/* 메인 후기 카드 */}
        <div className={`grid grid-cols-1 lg:grid-cols-5 gap-6 mb-8 anim-fade-up ${isVisible ? 'is-visible' : ''}`} style={{ transitionDelay: isVisible ? '150ms' : '0ms' }}>
          {/* 활성 후기 */}
          <div className="lg:col-span-3 bg-white/10 border border-white/15 rounded-2xl p-6 md:p-8 backdrop-blur-sm relative overflow-hidden">
            <div className="absolute top-6 right-8 text-white/5 text-9xl font-serif leading-none select-none">&ldquo;</div>
            <div className="flex items-center gap-1 mb-5">
              {Array.from({ length: testimonials[active].rating }).map((_, i) => (
                <i key={i} className="ri-star-fill text-[#C9A84C] text-sm" />
              ))}
            </div>
            <p className="text-white/85 text-sm md:text-base leading-relaxed mb-8 relative z-10">
              &ldquo;{testimonials[active].review}&rdquo;
            </p>
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <div className="w-14 h-14 rounded-full overflow-hidden border-2 border-[#C9A84C]/50 flex-shrink-0">
                <img src={testimonials[active].avatar} alt={testimonials[active].name} className="w-full h-full object-cover object-top" />
              </div>
              <div>
                <p className="text-white font-black text-base">{testimonials[active].name}</p>
                <p className="text-[#C9A84C] text-xs font-semibold mt-0.5">{testimonials[active].course}</p>
                <p className="text-white/40 text-xs mt-0.5">{testimonials[active].period}</p>
              </div>
              <div className="sm:ml-auto">
                <span className="inline-block bg-[#C9A84C]/15 border border-[#C9A84C]/30 text-[#C9A84C] text-xs font-bold px-3 py-1.5 rounded-sm">
                  {testimonials[active].tag}
                </span>
              </div>
            </div>
          </div>

          {/* 사이드 후기 목록 */}
          <div className="lg:col-span-2 flex flex-col gap-3">
            {testimonials.map((t, i) => (
              <button key={t.id} onClick={() => setActive(i)}
                className={`w-full text-left p-4 rounded-xl border transition-all duration-200 cursor-pointer ${active === i ? 'bg-white/15 border-[#C9A84C]/50' : 'bg-white/5 border-white/10 hover:bg-white/10'}`}
              >
                <div className="flex items-center gap-3">
                  <div className={`w-10 h-10 rounded-full overflow-hidden flex-shrink-0 border-2 transition-colors ${active === i ? 'border-[#C9A84C]' : 'border-white/20'}`}>
                    <img src={t.avatar} alt={t.name} className="w-full h-full object-cover object-top" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between gap-2">
                      <p className={`font-bold text-sm truncate ${active === i ? 'text-white' : 'text-white/70'}`}>{t.name}</p>
                      <div className="flex items-center gap-0.5 flex-shrink-0">
                        {Array.from({ length: 5 }).map((_, si) => (
                          <i key={si} className="ri-star-fill text-[#C9A84C] text-xs" />
                        ))}
                      </div>
                    </div>
                    <p className={`text-xs truncate mt-0.5 ${active === i ? 'text-[#C9A84C]' : 'text-white/40'}`}>{t.course}</p>
                  </div>
                </div>
                {active === i && (
                  <p className="text-white/60 text-xs leading-relaxed mt-3 line-clamp-2">{t.review}</p>
                )}
              </button>
            ))}
          </div>
        </div>

        {/* 하단 통계 바 */}
        <div className={`grid grid-cols-3 gap-4 border-t border-white/10 pt-8 anim-fade-up ${isVisible ? 'is-visible' : ''}`} style={{ transitionDelay: isVisible ? '300ms' : '0ms' }}>
          {[
            { value: '4.9', label: '평균 만족도', sub: '5점 만점' },
            { value: '98%', label: '재수강 추천율', sub: '수료생 설문 기준' },
            { value: '1,200+', label: '누적 수료생', sub: '2010년 이후' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="text-xl md:text-2xl lg:text-3xl font-black text-[#C9A84C]">{stat.value}</p>
              <p className="text-white text-xs md:text-sm font-semibold mt-1">{stat.label}</p>
              <p className="text-white/40 text-xs mt-0.5 hidden sm:block">{stat.sub}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
